import React from 'react';
import PropTypes from 'prop-types';

/**
 * MediaContent - A wrapper that renders a standard HTML div with Bulma class names
 *
 * This component accepts the same props as Bloomer MediaContent for easy migration
 */
const MediaContent = ({ className, children, style, ...props }) => {
  // Build the class names based on props
  const getClassNames = () => {
    const classes = ['media-content'];

    // Add custom class names
    if (className) {
      classes.push(className);
    }

    return classes.join(' ');
  };

  return (
    <div className={getClassNames()} style={style} {...props}>
      {children}
    </div>
  );
};

MediaContent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
};

MediaContent.defaultProps = {
  className: '',
  style: {},
  children: null,
};

export default MediaContent;
